import React, {
  useState,
  FC,
  useEffect,
  useImperativeHandle,
  forwardRef,
  createRef,
  useRef,
  Fragment,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Draggable, DraggableProvided } from "react-beautiful-dnd";
import { Accordion } from "react-bootstrap";
import { Button, InputField } from "elements";
import { Select, DatePicker, Popover, Progress } from "antd";
import cc from "classnames";
import moment, { Moment } from "moment";
import { LoadingOutlined } from "@ant-design/icons";

import { DeleteItemModal } from "../DeleteItemModal";

import { ReactComponent as EditIcon } from "assets/svg/editBox.svg";
import { ReactComponent as DeleteIcon } from "assets/svg/deleteBox.svg";
import { ReactComponent as CloseIcon } from "assets/svg/closeCricle.svg";

import {
  Wrapper,
  Col,
  Dragger,
  // UserPicture,
  InputGroup,
  NameContent,
  NameWrapper,
  NameContainer,
  ProgressWrapper,
  StatusIconWrapper,
  Head
} from "./styled";

// @ts-ignore
import classes from "./styled.module.scss";

import moveIcon from "./move.svg";

import { IItem } from "../@types";

// @ts-ignore
import { updateActionItem } from "modules/actions/PlanActions";

// @ts-ignore
import { weightsList, durationList } from "constants";

// @ts-ignore
import { validateEmail, useUser } from "utils/utility";
import InviteUserModal from "../InviteUserModal";
import {
  ValidateDeadLineValue,
  ValidateStartLineValue,
} from "../../../../utils/validateValue";
import ErrorTooltip from "../../../../components/ErrorTooltip";

import { NoteContainer } from "../Note/styled";
import AddNoteModal from "../../Modal/AddNoteModal";

import { ReactComponent as CalanderIcon } from "../Category/calander.svg";
import { isColumnVisible } from "../../../../utils/helper";
import { ActionItemsModal } from "components/ActionItemsModal";
import SelectMetric from "../Category/SelectMetric";
// @ts-ignore
import ManageCustomMetricsModal from "../../Modal/ManageCustomMetrics";
// @ts-ignore
import { createNewActionItemsModal } from "../../../../modules/actions/PlanActions";
import StatusSlider from "../../../../components/StatusSlider";
import { statusOptions } from "../../../ProjectPlanner/components/GoalSettings/data";
import { successToast, undoToast } from "../../../../utils/toast";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FrozenWrapper, UnFrozenWrapper } from "../styled";
import { CheckedItems } from "../../../../@types/commontypes";
import {
  allowedKeys,
  controlKeys,
} from "../../../ProjectPlanner/components/GoalSettings/utils";

const { Option } = Select;

interface IProps {
  data?: IItem;
  additionalData?: {
    plan_start_date: string | null;
    plan_end_date: string | null;
    category_start_date: string | null;
    category_end_date: string | null;
  };
  setEdit?: (value: boolean) => void;
  isNew?: boolean;
  projectPlanId: number;
  isShared?: boolean;
  index?: number;
  onCreate?: (values: string) => void;
  isExpandAll?: boolean;
  isAdd?: boolean;
  setIsAdd?: (value: boolean) => void;
  customizeColumns?: any;
  PlanDetails?: any;
  setIsProgressLoading?: (value: boolean) => void;
  categoryId?: number;
  checkedItems?: any;
  setCheckedItems?: any;
  isCategoryActive?: boolean;
  provided?: DraggableProvided;
}

interface IHandle {
  focusInput: () => void;
}

interface IDraggableItemProps {
  data: IItem;
  additionalData?: {
    plan_start_date: string | null;
    plan_end_date: string | null;
    category_start_date: string | null;
    category_end_date: string | null;
  };
  projectPlanId: number;
  isShared: boolean;
  index: number;
  isExpand?: boolean;
  customizeColumns?: any;
  PlanDetails?: any;
  status?: any;
  setIsProgressLoading?: (value: boolean) => void;
  checkedItems?: CheckedItems;
  setCheckedItems?: React.Dispatch<React.SetStateAction<CheckedItems>>;
  categoryId?: any;
  isCategoryActive?: boolean;
}

/* interface INewItemProps {
  projectPlanId: number;
  onCreate: (values: string) => void;
} */

export const DraggableItem: FC<IDraggableItemProps> = ({
  data,
  additionalData,
  projectPlanId,
  isShared,
  index = 0,
  isExpand,
  customizeColumns,
  PlanDetails,
  setIsProgressLoading,
  checkedItems,
  setCheckedItems,
  categoryId,
  isCategoryActive = true,
}) => {
  const { id } = data;

  return (
    <Draggable
      key={id}
      draggableId={id.toString()}
      index={index}
      isDragDisabled={!isCategoryActive}
    >
      {(provided) => (
        <Wrapper ref={provided.innerRef} {...provided.draggableProps}>
          <Item
            data={data}
            additionalData={additionalData}
            projectPlanId={projectPlanId}
            isShared={isShared}
            isExpandAll={isExpand}
            customizeColumns={customizeColumns}
            PlanDetails={PlanDetails}
            setIsProgressLoading={setIsProgressLoading}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            isCategoryActive={isCategoryActive}
            categoryId={categoryId}
            provided={provided}
          />
        </Wrapper>
      )}
    </Draggable>
  );
};

export const NewItem = forwardRef<IHandle, IProps>(
  ({ projectPlanId, onCreate, isAdd, setIsAdd }, ref) => {
    return (
      <Wrapper>
        <Item
          isNew
          projectPlanId={projectPlanId}
          onCreate={onCreate}
          setIsAdd={setIsAdd}
          isAdd={isAdd}
        />
      </Wrapper>
    );
  }
);

const Item = forwardRef<IHandle, IProps>(
  (
    {
      data,
      additionalData,
      isNew,
      setEdit,
      setIsAdd,
      projectPlanId,
      isShared = false,
      onCreate,
      isExpandAll,
      isAdd,
      customizeColumns,
      PlanDetails,
      setIsProgressLoading,
      categoryId,
      checkedItems,
      setCheckedItems,
      isCategoryActive = true,
      provided,
    },
    ref
  ) => {
    const {
      id,
      name,
      duration,
      weight,
      plan_progress,
      responsible_person,
      start_line,
      dead_line,
      start,
      current,
      target,
      notes,
      status,
      label,
      priority,
      metric_unit,
      custom_unit,
      metric_unit_name,
      custom_unit_name,
    } = data || ({} as IItem);

    const { planDetails, updateStatusLoading, updateActionitemLoading } =
      useSelector((state: any) => state.plan.plan);

    const dispatch = useDispatch();
    const user = useUser();

    const [searchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();

    const actionItemId = searchParams.get("actionItemId");
    const [updateNameId, setUpdateNameId] = useState<number | null>(null);

    const isActionItemRoute =
      location.pathname.includes("plan-details") && actionItemId;

    const onwerEmail = planDetails?.invited_owner;
    const userEmail = user?.email;
    const isOnwer = onwerEmail === userEmail;

    const [IsAddMetric, setIsAddMetric] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [isEditName, setIsEditName] = useState(false);
    const [editNameValue, setEditNameValue] = useState("");

    const [itemName, setItemName] = useState("");
    const [emailToSearch, setEmailToSearch] = useState("");
    const [emailToInvite, setEmailToInvite] = useState<string | null>(null);
    const [isExpand, setIsExpand] = useState(true);
    const [isAddNote, setIsAddNote] = useState(false);
    const [isNote, setIsNote] = useState(false);

    const [isNoteModel, setIsNoteModel] = useState(false);
    const [isEditNote, setIsEditNote] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const isWeight = isColumnVisible(customizeColumns, "weight");
    const isPlanProgress = isColumnVisible(customizeColumns, "plan_progress");
    const isStatus = isColumnVisible(customizeColumns, "status");
    const isMeasurement = isColumnVisible(customizeColumns, "measurement");
    const isStartLine = isColumnVisible(customizeColumns, "start_date");
    const isEndLine = isColumnVisible(customizeColumns, "due_date");
    const isDuration = isColumnVisible(customizeColumns, "duration");
    const isAssignee = isColumnVisible(customizeColumns, "assignee");
    const [modalOpen, setModalOpen] = useState(false);
    const [measurementPop, setMeasurementPop] = useState(false);
    const [measureLoading, setMeasureLoading] = useState(false);

    const [selectStatus, setSelectStatus] = useState(status || 1);
    const [selectedValue, setSelectedValue] = useState<any>();
    const [selectedUnit, setSelectedUnit] = useState<string | null>();
    const [isStatusPop, setIsStatusPop] = useState(false);
    const [isProgressPop, setIsProgressPop] = useState(false);
    const [isStatusLoading, setIsStatusLoading] = useState({
      type: "",
      loading: false,
    });

    const [actionProgress, setActionProgress] = useState<number | 0>();

    const nameInputRef = useRef<HTMLDivElement>(null);

    const StatusInfo = statusOptions[selectStatus - 1];

    const [values, setValues] = useState({
      start: start || null,
      current: current || null,
      target: target || null,
    });

    const notesData = notes ? notes[0] : null;

    useEffect(() => {
      if (isExpandAll && notesData && notesData?.context) {
        setIsExpand(true);
      } else {
        setIsExpand(false);
      }
    }, [isExpandAll]);

    useEffect(() => {
      setValues({
        start: start || null,
        current: current || null,
        target: target || null,
      });

      if (metric_unit_name || custom_unit_name) {
        const findCustomLabel =
          planDetails?.goal?.custom_labels?.length > 0 &&
          planDetails?.goal?.custom_labels
            ?.map((label: any) => {
              const customUnit = label?.custom_unit_options?.find(
                (option: any) => option.id === custom_unit
              );

              if (customUnit) {
                return {
                  label: customUnit?.value,
                  customUnit: customUnit?.id,
                };
              }
              return null;
            })
            ?.filter(Boolean);

        setSelectedUnit(
          label === "custom" ? findCustomLabel?.[0]?.label : metric_unit_name
        );

        setSelectedValue({
          label:
            label === "custom" ? findCustomLabel?.[0]?.label : metric_unit_name,
          unit:
            label === "custom" ? findCustomLabel?.[0]?.customUnit : metric_unit,
          unitId:
            label === "custom" ? findCustomLabel?.[0]?.customUnit : metric_unit,
        });
      }
    }, [measurementPop]);

    useEffect(() => {
      setActionProgress(plan_progress);
    }, [plan_progress]);

    const [isDeleted, setIsDeleted] = useState(false);

    const { users: planUsers } = useSelector(
      (state: any) => state.user.projectOwners
    );

    const selectedOwner = planUsers.find(
      (owner: { id: number }) => owner?.id === responsible_person?.id
    );
    const otherOwners = planUsers.filter(
      (owner: { id: number }) => owner?.id !== responsible_person?.id
    );
    const orderedPlanUsers = selectedOwner
      ? [selectedOwner, ...otherOwners]
      : planUsers;

    const filteredUsers = orderedPlanUsers?.filter((owner: { email: string }) =>
      owner.email.toLowerCase().includes(emailToSearch.toLowerCase())
    );

    const $inputRef = createRef<HTMLInputElement>();

    useImperativeHandle(ref, () => ({
      focusInput: () => {
        setIsEdit(true);
      },
    }));

    useEffect(() => {
      if (isEdit && $inputRef.current) {
        $inputRef.current.focus();
      }
    }, [isEdit, $inputRef]);

    useEffect(() => {
      if (isNew && $inputRef.current) {
        $inputRef.current.focus();
      }
    }, [isNew]);

    useEffect(() => {
      if (isEditName && $inputRef.current) {
        $inputRef.current.focus();
      }
    }, [isEditName]);

    useEffect(() => {
      if (isAdd) setIsActive(true);
    }, [isAdd]);

    useEffect(() => {
      if (isActive && $inputRef.current) {
        $inputRef.current.focus();
      }
    }, [isActive]);

    const handleEdit = () => {
      if (!isCategoryActive) return;
      setItemName(name || "");
      setIsEditNote(true);
      setIsNoteModel(true);
    };

    const handleCancel = () => {
      setIsEdit(false);
      setEdit?.(false);
      setIsAdd?.(false);
    };

    const handleKeyDownEdit = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        setIsEdit(false);
        setEdit && setEdit(false);
        setIsAdd && setIsAdd(false);
        changeName();
      } else if (e.key === "Escape") {
        setIsEdit(false);
        setEdit && setEdit(false);
        setIsAdd && setIsAdd(false);
        setItemName(name || "");
      }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      let input = e.target.value;

      if (input?.startsWith(" ")) {
        input = input.trim();
      }

      if (input.length > 255) {
        input = input.slice(0, 255);
      }

      setItemName(input);
    };

    const changeName = () => {
      if (!itemName) return;

      if (isNew && onCreate) {
        onCreate(itemName);
        setItemName("");
      } else {
        dispatch(
          updateActionItem(id, { name: itemName }, projectPlanId, true, () => {
            successToast("Action item name updated successfully");
          })
        );
      }

      setItemName("");
    };

    const startLineDate = additionalData?.category_start_date;
    const endLineDate = additionalData?.category_end_date;
    const planStartDate = additionalData?.plan_start_date;
    const planEndDate = additionalData?.plan_end_date;

    const isDateDisabled = (
      current: Moment,
      name: "start_line" | "dead_line"
    ): boolean => {
      if (!current) return false;

      if (name === "start_line") {
        if (
          (additionalData?.plan_start_date &&
            current.isBefore(moment(additionalData.plan_start_date), "day")) ||
          (additionalData?.category_start_date &&
            current.isBefore(moment(additionalData.category_start_date), "day"))
        ) {
          return true;
        }
        if (
          (additionalData?.plan_end_date &&
            current.isAfter(moment(additionalData.plan_end_date), "day")) ||
          (additionalData?.category_end_date &&
            current.isAfter(moment(additionalData.category_end_date), "day"))
        ) {
          return true;
        }
      } else if (name === "dead_line") {
        if (
          (additionalData?.plan_start_date &&
            current.isBefore(moment(additionalData.plan_start_date), "day")) ||
          (additionalData?.category_start_date &&
            current.isBefore(moment(additionalData.category_start_date), "day"))
        ) {
          return true;
        }
        if (
          (additionalData?.plan_end_date &&
            current.isAfter(moment(additionalData.plan_end_date), "day")) ||
          (additionalData?.category_end_date &&
            current.isAfter(moment(additionalData.category_end_date), "day"))
        ) {
          return true;
        }

        if (start_line && current.isBefore(moment(start_line), "day")) {
          return true;
        }
      }

      return false;
    };

    const startLineError = ValidateStartLineValue(
      start_line || null,
      startLineDate || null,
      endLineDate || null
    );

    const deadLineError = ValidateDeadLineValue(
      dead_line || null,
      startLineDate || null,
      endLineDate || null,
      start_line || null
    );

    const handleKeyDownPreventMinus = (
      e: React.KeyboardEvent<HTMLInputElement>
    ) => {
      const target = e.target as HTMLInputElement;
      const currentValue = target.value;

      if (e.key === "-" && currentValue.length > 0) {
        e.preventDefault();
      }

      if (e.key === "0" && currentValue === "-") {
        e.preventDefault();
      }

      if (!allowedKeys.includes(e.key) && !controlKeys.includes(e.key)) {
        e.preventDefault();
      }

      if (e.key === "." || e.key === "+") {
        e.preventDefault();
      }
    };

    const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;

      if (
        value === "" ||
        value === "-" ||
        /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/.test(value)
      ) {
        setValues((prev) => ({
          ...prev,
          [name]: value === "" ? null : value,
        }));
      }
    };

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      const { name, value } = e.target;

      if (value && typeof value === "string" && value.endsWith(".00")) {
        const cleanValue = value.replace(".00", "");
        setValues((prev) => ({
          ...prev,
          [name]: cleanValue,
        }));
      }
    };

    const handleAssignNewUser = (newUserId: number) => {

      dispatch(
        updateActionItem(
          id,
          { responsible_person: newUserId }, 
          projectPlanId,
          true,
          () => {
            successToast("Assignee updated successfully");
            setEmailToInvite(null); 
          }
        )
      );
    };

    const handleBlurInput = (e: React.FocusEvent<HTMLInputElement>) => {
      const { name, value } = e.target;

      if (value && !isNaN(Number(value))) {
        const formattedValue = Number(value).toFixed(2);
        setValues((prev) => ({
          ...prev,
          [name]: formattedValue,
        }));
      }
    };

    const handleUpdateMeasurement = () => {
      setMeasureLoading(true);
      const unitKey = selectedValue.isCustom ? "custom_unit" : "metric_unit";
      let payload = {
        start: Number(values.start).toFixed(2),
        current: Number(values.current).toFixed(2),
        target: Number(values.target).toFixed(2),
        [unitKey]: selectedValue?.unitId,
      };

      if (selectedValue?.isCustom) {
        payload = {
          ...payload,
          label: "custom",
        };
      } else {
        payload = {
          ...payload,
          label: "",
        };
      }

      dispatch(
        updateActionItem(id, payload, projectPlanId, true, () => {
          successToast("Measurement updated successfully");
          setMeasurementPop(false);
          setMeasureLoading(false);
        })
      );
    };

    useEffect(() => {
      setSelectStatus(status || 1);
    }, [status]);

    const isUnitChanged =
      selectedValue !== undefined
        ? label === "custom"
          ? selectedValue?.unitId === custom_unit
          : selectedValue?.unitId === metric_unit
        : true;

    const disableSaveButton = !isUnitChanged
      ? !values?.start || !values?.current || !values?.target || false
      : !selectedValue ||
        selectedValue?.length === 0 ||
        !values?.start ||
        !values?.current ||
        !values?.target ||
        ((values.start === start ||
          (values.start && start && `${values.start}.00` === start)) &&
          (values.current === current ||
            (values.current &&
              current &&
              `${values.current}.00` === current)) &&
          (values.target === target ||
            (values.target && target && `${values.target}.00` === target)));

    const UserName =
      responsible_person?.first_name && responsible_person?.last_name
        ? responsible_person?.first_name.substring(0, 1) +
          responsible_person?.last_name.substring(0, 1)
        : responsible_person?.name
        ? responsible_person?.name.split(" ").length > 1
          ? responsible_person.name.split(" ")[0].substring(0, 1) +
            responsible_person.name.split(" ")[1].substring(0, 1)
          : responsible_person.name.substring(0, 2)
        : responsible_person?.email?.substring(0, 2);

    const handleAddMetric = () => {
      setModalOpen(true);
      setMeasurementPop(false);
    };

    const onActionItemKeyUp = (e: any) => {
      if (e.key === "Enter") {
        handleChangeItemName();
      }

      if (e.key === "Escape") {
        setIsEditName(false);
        setEditNameValue(name ?? "");
      }
    };

    const handleCloseAction = () => {
      setUpdateNameId(null);
      setIsEditName(false);
      setEditNameValue(name ?? "");
      undoToast(
        "Action item name updated successfully",
        "Success!",
        handleUndo
      );
    };

    const handleUndo = () => {
      const payload = {
        action_item: {
          name: name,
          id: id,
        },
      };

      dispatch(
        createNewActionItemsModal(
          payload,
          projectPlanId,
          null,
          () => {
            successToast("Action item name restored successfully");
          },
          false
        )
      );
    };

    const handleChangeItemName = async () => {
      if (!editNameValue || editNameValue === "" || editNameValue === name)
        return;
      setUpdateNameId(id);

      const payload = {
        action_item: {
          name: editNameValue,
          id: id,
        },
      };

      dispatch(
        createNewActionItemsModal(
          payload,
          projectPlanId,
          null,
          handleCloseAction,
          false
        )
      );
    };

    useEffect(() => {
      if (isActionItemRoute && id === Number(actionItemId)) {
        handleEdit();
        navigate(`/project-planner/plan-details/${projectPlanId}`, {
          replace: true,
        });
      }
    }, [isActionItemRoute]);

    const FrozenHeadItem = () => (
      <>
        <Col $active={isCategoryActive} $type="small" $isCheckbox>
          <input
            type="checkbox"
            disabled={!isCategoryActive || isShared || isNew}
            style={{
              cursor:
                isShared || isNew
                  ? "not-allowed"
                  : isCategoryActive
                  ? "pointer"
                  : "default",
            }}
            checked={checkedItems?.[categoryId ?? 0]?.items?.[id] || false}
            onChange={(e) => {
              if (isShared || categoryId == null) return;
              const isChecked = e.target.checked;
              setCheckedItems((prev: any) => {
                const updatedItems = {
                  ...prev[categoryId]?.items,
                  [id]: isChecked,
                };

                const allItemsChecked = Object.values(updatedItems).every(
                  (checked) => checked
                );

                return {
                  ...prev,
                  [categoryId]: {
                    ...prev[categoryId],
                    items: updatedItems,
                    category: allItemsChecked,
                  },
                };
              });
            }}
          />
        </Col>

        <Col $active={isCategoryActive} $type="small">
          {!isShared && (
            <Dragger
              {...provided?.dragHandleProps}
              $disabled={isShared || !isCategoryActive}
              title={isShared ? "" : "Drag to reorder..."}
              data-testid="drag-button"
              style={{
                cursor: isCategoryActive ? "pointer" : "default",
              }}
            >
              <img src={moveIcon} alt="" />
            </Dragger>
          )}
        </Col>

        <Accordion
          as={Col}
          activeKey={isExpand && !isEdit ? "1" : "0"}
          $active={isCategoryActive}
          $type="large"
        >
          <InputGroup>
            <NameContent $disabled={isShared} $active={isCategoryActive}>
              <NameContainer
                $collapsed={notesData ? !(isExpand && !isEdit) : true}
              >
                <NameWrapper ref={nameInputRef}>
                  {isAdd && !isShared ? (
                    <>
                      <InputField
                        name="name"
                        value={itemName}
                        parentStyle={{ width: "100%" }}
                        placeholder="Action item name"
                        ref={$inputRef}
                        onChange={handleChange}
                        onKeyDown={handleKeyDownEdit}
                        data-testid="name-input"
                        style={{ width: "100%" }}
                      />

                      <Button
                        size="md"
                        styleType="secondary"
                        style={{
                          whiteSpace: "nowrap",
                        }}
                        onClick={(e: React.MouseEvent) => {
                          e.stopPropagation();
                          handleCancel();
                        }}
                        onMouseDown={(e: React.MouseEvent) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleCancel();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        size="md"
                        style={{
                          whiteSpace: "nowrap",
                        }}
                        onClick={(e: React.MouseEvent) => {
                          e.stopPropagation();
                          changeName();
                        }}
                        onMouseDown={(e: React.MouseEvent) => {
                          e.stopPropagation();
                          changeName();
                        }}
                        disabled={isNew && !itemName}
                      >
                        Save
                      </Button>
                    </>
                  ) : isEditName ? (
                    <>
                      <InputField
                        name="name"
                        ref={$inputRef}
                        value={editNameValue}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          setEditNameValue(e.target.value)
                        }
                        parentStyle={{ width: "100%" }}
                        onKeyUp={onActionItemKeyUp}
                        disabled={!isCategoryActive}
                        placeholder="Action item name"
                        style={{
                          padding: "8px 10px",
                          width: "100%",
                          border: "1px solid #71AACA",
                          borderRadius: "4px",
                          boxShadow: "0px 0px 0px 2px rgba(208, 227, 237, 1)",
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#404040",
                        }}
                      />

                      <Button
                        size="md"
                        styleType="secondary"
                        style={{
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          setIsEditName(false);
                          setEditNameValue(name ?? "");
                        }}
                        onMouseDown={(e: React.MouseEvent) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleCancel();
                        }}
                        disabled={updateActionitemLoading}
                      >
                        Cancel
                      </Button>
                      
                      <Button
                        size="md"
                        style={{
                          whiteSpace: "nowrap",
                        }}
                        disabled={
                          !editNameValue ||
                          editNameValue === "" ||
                          editNameValue === name ||
                          updateActionitemLoading
                        }
                        onClick={() => {
                          handleChangeItemName();
                        }}
                        loading={updateNameId === id && updateActionitemLoading}
                      >
                        {updateNameId === id && updateActionitemLoading ? (
                          <LoadingOutlined />
                        ) : (
                          "Save"
                        )}
                      </Button>
                    </>
                  ) : (
                    <span
                      data-testid="name-value"
                      onDoubleClick={() => {
                        if (!isCategoryActive) return;
                        setIsEditName(true);
                        setEditNameValue(name ?? "");
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        textDecoration:
                          Number(actionProgress) === 10
                            ? "line-through"
                            : "none",
                        cursor: isCategoryActive ? "pointer" : "default",
                      }}
                    >
                      {name}
                      {[1, 2, 3].includes(priority) && (
                        <span
                          style={{
                            height: "max-content",
                            whiteSpace: "nowrap",
                            display: "inline-block",
                            marginLeft: "8px",
                            padding: "2px 8px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            fontWeight: "400",
                            color: (() => {
                              switch (priority) {
                                case 1:
                                  return "#458C0A"; // Low
                                case 2:
                                  return "#1271A6"; // Medium
                                case 3:
                                  return "#F00000"; // High
                                default:
                                  console.warn(
                                    `Unrecognized priority value: ${priority}`
                                  );
                                  return "#458C0A"; // default set to Low
                              }
                            })(),
                            backgroundColor: (() => {
                              switch (priority) {
                                case 1:
                                  return "#EDFDC6"; // Low
                                case 2:
                                  return "#D0E3ED"; // Medium
                                case 3:
                                  return "#FAD6D6"; // High
                                default:
                                  return "#EDFDC6"; // default set to Low
                              }
                            })(),
                          }}
                        >
                          {(() => {
                            switch (priority) {
                              case 1:
                                return "Low";
                              case 2:
                                return "Medium";
                              case 3:
                                return "High";
                              default:
                                return "Low";
                            }
                          })()}
                        </span>
                      )}
                    </span>
                  )}
                </NameWrapper>

                <div>
                  {isNew ? null : (
                    <>
                      {!isShared && !isEditName && (
                        <NoteContainer
                          className={`${
                            isCategoryActive
                              ? "action-items"
                              : "action-items-disabled"
                          }`}
                        >
                          <EditIcon
                            onClick={handleEdit}
                            style={{
                              cursor: isCategoryActive ? "pointer" : "default",
                            }}
                          />

                          <DeleteIcon
                            onClick={() => {
                              if (!isCategoryActive) return;
                              setIsDeleted(true);
                            }}
                            style={{
                              cursor: isCategoryActive ? "pointer" : "default",
                            }}
                          />
                        </NoteContainer>
                      )}
                    </>
                  )}
                </div>
              </NameContainer>
            </NameContent>
          </InputGroup>
        </Accordion>
      </>
    );

    const UnFrozenHeadItem = ({
      column,
      isFrozen,
      key,
    }: {
      column: any;
      isFrozen?: boolean;
      key: string;
    }) => {
      if (!column || column.key === "action_items") return null;

      const shouldRender =
        (!isFrozen && !column.isFrozen) || (isFrozen && column.isFrozen);

      if (!shouldRender) return null;

      if (key === "weight") {
        return (
          isWeight && (
            <Col
              className={cc(classes.weightSelect)}
              $active={isCategoryActive}
              $type="medium"
            >
              {isNew ? null : (
                <Select
                  className={cc(
                    isCategoryActive
                      ? classes.cursorPointer
                      : classes.cursorDefault,
                    classes.dropdown,
                    classes.weight,
                    classes.customArrow
                  )}
                  getPopupContainer={(trigger) =>
                    trigger.closest(".category-container") || document.body
                  }
                  placeholder="0"
                  dropdownMatchSelectWidth={false}
                  dropdownRender={(menu) => (
                    <div className="weightlist">{menu}</div>
                  )}
                  value={{ key: weight.toString(), value: weight / 10 }}
                  disabled={isShared || !isCategoryActive}
                  onChange={(value, _) => {
                    dispatch(
                      updateActionItem(
                        id,
                        { weight: Number(value) * 10 },
                        projectPlanId,
                        true,
                        () => {
                          successToast("Weight updated successfully");
                        }
                      )
                    );
                  }}
                  data-testid="weight-select"
                >
                  {weightsList.map(
                    (count: { value: number; key: string }, index: number) => (
                      <Option key={index} value={count.value}>
                        {count.key}
                      </Option>
                    )
                  )}
                </Select>
              )}
            </Col>
          )
        );
      }

      if (key === "plan_progress") {
        return (
          isPlanProgress && (
            <Col
              className={cc(classes.weightSelect)}
              $active={isCategoryActive}
              $type="medium"
            >
              {isNew ? null : (
                <Popover
                  overlayClassName="status_popover"
                  content={
                    <StatusSlider
                      selectStatus={selectStatus}
                      planProgress={actionProgress}
                      id={id}
                      projectPlanId={projectPlanId}
                      open={isProgressPop}
                      isStatusLoading={isStatusLoading}
                      setIsStatusLoading={setIsStatusLoading}
                      onClose={() => setIsProgressPop(false)}
                      setIsProgressLoading={setIsProgressLoading}
                    />
                  }
                  getPopupContainer={(trigger) =>
                    trigger.closest(".category-container") || document.body
                  }
                  trigger="click"
                  placement="right"
                  open={isShared || !isCategoryActive ? false : isProgressPop}
                  onOpenChange={(value) => {
                    if (!isCategoryActive) return;
                    setIsProgressPop(value);
                  }}
                >
                  <ProgressWrapper
                    style={{
                      cursor: isCategoryActive ? "pointer" : "default",
                    }}
                  >
                    <Progress
                      percent={actionProgress ? actionProgress * 10 : 0}
                      strokeColor={statusOptions[selectStatus - 1].color}
                      showInfo={false}
                      width={54}
                    />

                    <span
                      style={{
                        color: statusOptions[selectStatus - 1].color,
                      }}
                    >
                      {actionProgress || 0}/10
                    </span>
                  </ProgressWrapper>
                </Popover>
              )}
            </Col>
          )
        );
      }

      if (key === "status") {
        return isNew
          ? null
          : isStatus && (
              <Col $active={isCategoryActive} $type="medium">
                {isNew ? null : (
                  <Popover
                    overlayClassName="status_popover"
                    open={isShared || !isCategoryActive ? false : isStatusPop}
                    onOpenChange={(value) => {
                      if (!isCategoryActive) return;
                      setIsStatusPop(value);
                    }}
                    content={
                      <StatusSlider
                        selectStatus={selectStatus}
                        planProgress={actionProgress}
                        id={id}
                        projectPlanId={projectPlanId}
                        open={isShared ? false : isStatusPop}
                        isStatusLoading={isStatusLoading}
                        setIsStatusLoading={setIsStatusLoading}
                        onClose={() => setIsStatusPop(false)}
                      />
                    }
                    getPopupContainer={(trigger) =>
                      trigger.closest(".category-container") || document.body
                    }
                    trigger="click"
                    placement="right"
                  >
                    <StatusIconWrapper
                      style={{
                        cursor: isCategoryActive ? "pointer" : "default",
                      }}
                    >
                      {StatusInfo?.circleIcon && <StatusInfo.circleIcon />}
                      <span>{StatusInfo.label}</span>
                    </StatusIconWrapper>
                  </Popover>
                )}
              </Col>
            );
      }

      if (key === "measurement") {
        return isNew
          ? null
          : isMeasurement && (
              <Col $active={isCategoryActive} $type="medium">
                <Popover
                  content={
                    <div className="measurement-popover">
                      <div className="measurement-popover-items">
                        <div className="measurement-popover-item">
                          <label>Metric</label>

                          <SelectMetric
                            onAddMetric={handleAddMetric}
                            selectedValue={selectedValue}
                            setSelectedValue={setSelectedValue}
                            selectedUnit={selectedUnit}
                            setSelectedUnit={setSelectedUnit}
                            setIsAddMetric={setIsAddMetric}
                          />
                        </div>
                        <div className="measurement-popover-item">
                          <label>Start</label>
                          <input
                            name="start"
                            type="text"
                            value={values?.start || ""}
                            placeholder="0"
                            disabled={isShared || !selectedValue}
                            onFocus={handleFocus}
                            onBlur={handleBlurInput}
                            onChange={handleChangeInput}
                            onKeyDown={handleKeyDownPreventMinus}
                            style={{ width: "50px" }}
                          />
                        </div>

                        <div className="measurement-popover-item">
                          <label>Current</label>
                          <input
                            name="current"
                            type="text"
                            value={values?.current || ""}
                            placeholder="0"
                            disabled={isShared || !selectedValue}
                            onFocus={handleFocus}
                            onBlur={handleBlurInput}
                            onChange={handleChangeInput}
                            onKeyDown={handleKeyDownPreventMinus}
                            style={{ width: "50px" }}
                          />
                        </div>

                        <div className="measurement-popover-item">
                          <label>Target</label>

                          <input
                            name="target"
                            type="text"
                            value={values?.target || ""}
                            placeholder="0"
                            disabled={isShared || !selectedValue}
                            onFocus={handleFocus}
                            onBlur={handleBlurInput}
                            onChange={handleChangeInput}
                            onKeyDown={handleKeyDownPreventMinus}
                            style={{ width: "50px" }}
                          />
                        </div>
                      </div>

                      <div className="measurement-popover-actions">
                        <button
                          onClick={() => {
                            setMeasurementPop(false);
                            setSelectedUnit("");
                            setMeasureLoading(false);
                            setValues({
                              start: start || null,
                              current: current || null,
                              target: target || null,
                            });
                          }}
                        >
                          Cancel
                        </button>

                        <button
                          onClick={handleUpdateMeasurement}
                          disabled={
                            isShared || disableSaveButton || measureLoading
                          }
                        >
                          {measureLoading ? <LoadingOutlined /> : "Save"}
                        </button>
                      </div>
                    </div>
                  }
                  trigger="click"
                  placement="bottom"
                  overlayClassName="measurement-popover-overlay"
                  open={isShared || !isCategoryActive ? false : measurementPop}
                  onOpenChange={(value) => {
                    if (!isCategoryActive) return;
                    setMeasurementPop(value);
                  }}
                  autoAdjustOverflow
                  getPopupContainer={(trigger) =>
                    trigger.closest(".category-container") || document.body
                  }
                >
                  <div
                    style={{
                      cursor: isCategoryActive ? "pointer" : "default",
                    }}
                  >
                    {current || "--"}
                  </div>
                </Popover>
              </Col>
            );
      }

      if (key === "start_date") {
        return (
          isStartLine && (
            <Col $active={isCategoryActive} $type="medium">
              <div className={classes.datePicker_wrapper}>
                {isNew ? null : isShared ? (
                  start_line ? (
                    moment(start_line).format("YYYY-MM-DD")
                  ) : null
                ) : (
                  <DatePicker
                    className={`${classes.datepicker} ${
                      isCategoryActive
                        ? classes.cursorPointer
                        : classes.cursorDefault
                    }`}
                    format="MMM D"
                    defaultPickerValue={
                      start_line
                        ? moment(start_line)
                        : startLineDate
                        ? moment(startLineDate)
                        : moment(planStartDate || new Date())
                    }
                    getPopupContainer={(trigger) =>
                      trigger.closest(".category-container") || document.body
                    }
                    // suffixIcon={<LockIcon />}
                    suffixIcon={<CalanderIcon />}
                    disabledDate={(current) =>
                      isDateDisabled(current, "start_line")
                    }
                    allowClear={false}
                    disabled={isShared || !isOnwer || !isCategoryActive}
                    inputReadOnly
                    value={start_line ? moment(start_line) : null}
                    onChange={(date, value) => {
                      if (date) {
                        const formattedDate = date.format("YYYY-MM-DD");
                        dispatch(
                          updateActionItem(
                            id,
                            {
                              start_line: value ? formattedDate : null,
                            },
                            projectPlanId,
                            true,
                            () => {
                              successToast("Start date updated successfully");
                            }
                          )
                        );
                      } else {
                        dispatch(
                          updateActionItem(
                            id,
                            {
                              start_line: null,
                            },
                            projectPlanId,
                            true,
                            () => {
                              successToast("Start date updated successfully");
                            }
                          )
                        );
                      }
                    }}
                    data-testid="start-date"
                  />
                )}

                {startLineError && !isShared && (
                  <ErrorTooltip
                    title={startLineError || ""}
                    isDate={!start_line}
                  />
                )}

                {start_line && !isShared && (
                  <div className={classes.closeIcon}>
                    <CloseIcon
                      style={{
                        opacity: isCategoryActive ? 1 : 0,
                        visibility: isCategoryActive ? "visible" : "hidden",
                        cursor: isCategoryActive ? "pointer" : "default",
                      }}
                      onClick={() => {
                        if (isOnwer && isCategoryActive) {
                          dispatch(
                            updateActionItem(
                              id,
                              {
                                start_line: null,
                              },
                              projectPlanId,
                              true,
                              () => {
                                successToast("Start date updated successfully");
                              }
                            )
                          );
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            </Col>
          )
        );
      }

      if (key === "due_date") {
        return (
          isEndLine && (
            <Col $active={isCategoryActive} $type="medium">
              {isNew ? null : isShared ? (
                dead_line ? (
                  moment(dead_line).format("YYYY-MM-DD")
                ) : null
              ) : (
                <div className={classes.datePicker_wrapper}>
                  <DatePicker
                    className={`${classes.datepicker} ${
                      isCategoryActive
                        ? classes.cursorPointer
                        : classes.cursorDefault
                    }`}
                    format="MMM D"
                    suffixIcon={<CalanderIcon />}
                    allowClear={false}
                    defaultPickerValue={
                      dead_line
                        ? moment(dead_line)
                        : endLineDate
                        ? moment(endLineDate)
                        : moment(planEndDate || new Date())
                    }
                    getPopupContainer={(trigger) =>
                      trigger.closest(".category-container") || document.body
                    }
                    disabledDate={(current) =>
                      isDateDisabled(current, "dead_line")
                    }
                    disabled={isShared || !isOnwer || !isCategoryActive}
                    inputReadOnly
                    value={dead_line ? moment(dead_line) : null}
                    onChange={(date, value) => {
                      if (date) {
                        const formattedDate = date.format("YYYY-MM-DD");
                        dispatch(
                          updateActionItem(
                            id,
                            {
                              dead_line: value ? formattedDate : null,
                            },
                            projectPlanId,
                            true,
                            () => {
                              successToast("Due date updated successfully");
                            }
                          )
                        );
                      } else {
                        dispatch(
                          updateActionItem(
                            id,
                            {
                              dead_line: null,
                            },
                            projectPlanId,
                            true,
                            () => {
                              successToast("Due date updated successfully");
                            }
                          )
                        );
                      }
                    }}
                    data-testid="end-date"
                  />

                  {deadLineError && !isShared && (
                    <ErrorTooltip
                      title={deadLineError || ""}
                      isDate={!dead_line}
                    />
                  )}

                  {dead_line && !isShared && (
                    <div className={classes.closeIcon}>
                      <CloseIcon
                        style={{
                          opacity: isCategoryActive ? 1 : 0,
                          visibility: isCategoryActive ? "visible" : "hidden",
                          cursor: isCategoryActive ? "pointer" : "default",
                        }}
                        onClick={() => {
                          if (isOnwer && isCategoryActive) {
                            dispatch(
                              updateActionItem(
                                id,
                                {
                                  dead_line: null,
                                },
                                projectPlanId,
                                true,
                                () => {
                                  successToast("Due date updated successfully");
                                }
                              )
                            );
                          }
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            </Col>
          )
        );
      }

      if (key === "duration") {
        return (
          isDuration && (
            <Col $active={isCategoryActive} $type="medium">
              {isNew ? null : (
                <Select
                  className={cc(
                    classes.dropdown,
                    classes.duration,
                    isCategoryActive
                      ? classes.cursorPointer
                      : classes.cursorDefault
                  )}
                  placeholder="Select duration"
                  dropdownMatchSelectWidth={false}
                  value={duration === "00:00:00" ? "-" : duration}
                  disabled={isShared || !isCategoryActive}
                  getPopupContainer={(trigger) =>
                    trigger.closest(".category-container") || document.body
                  }
                  onChange={(value, _) =>
                    dispatch(
                      updateActionItem(
                        id,
                        { duration: value },
                        projectPlanId,
                        true,
                        () => {
                          successToast("Duration updated successfully");
                        }
                      )
                    )
                  }
                  data-testid="duration-select"
                >
                  {durationList.map(
                    (count: { value: string; key: string }, index: number) => (
                      <Option key={index} value={count.value}>
                        {count.key}
                      </Option>
                    )
                  )}
                </Select>
              )}
            </Col>
          )
        );
      }

      if (key === "assignee") {
        return isNew
          ? null
          : isAssignee && (
              <Col $active={isCategoryActive} $type="medium">
                {" "}
                <Select
                  onSelect={(value) => {
                    dispatch(
                      updateActionItem(
                        id,
                        { responsible_person: value },
                        projectPlanId,
                        true,
                        () => {
                          successToast("Assignee updated successfully");
                        }
                      )
                    );

                    setEmailToSearch("");
                  }}
                  getPopupContainer={(trigger) =>
                    trigger.closest(".category-container") || document.body
                  }
                  // value={responsible_person?.email?.substring(0, 2)}
                  value={UserName}
                  onSearch={(e) => setEmailToSearch(e)}
                  className={cc(
                    classes.dropdown,
                    classes.person,
                    isCategoryActive
                      ? classes.cursorPointer
                      : classes.cursorDefault
                  )}
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ minWidth: 200 }}
                  size="large"
                  filterOption={false}
                  showSearch
                  popupClassName="testing-popup"
                  notFoundContent={
                    validateEmail(emailToSearch) ? (
                      <Button
                        onClick={() => {
                          setEmailToInvite(emailToSearch);
                        }}
                      >
                        Invite {emailToSearch}
                      </Button>
                    ) : (
                      "No results. Enter email to invite"
                    )
                  }
                  disabled={isShared || !isCategoryActive}
                  placeholder="Select user"
                  data-testid="owner-select"
                  // open
                >
                  {filteredUsers?.map((owner: any, index: number) => {
                    return (
                      <Option
                        style={{ zIndex: "99999" }}
                        key={index}
                        value={owner?.id}
                        className={
                          owner?.public_id == responsible_person?.id ||
                          owner?.id == responsible_person?.id
                            ? classes.selected
                            : ""
                        }
                      >
                        <div className="hello">{owner?.email}</div>
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            );
      }
    };

    return (
      <>
        <DeleteItemModal
          itemId={id}
          itemName={name ?? ""}
          planId={projectPlanId}
          type="action"
          isVisible={isDeleted}
          onClose={() => setIsDeleted(false)}
          checkedItems={checkedItems}
          setCheckedItems={setCheckedItems}
        />

        <AddNoteModal
          allData={data}
          data={notesData}
          isVisible={isNote}
          isName={itemName}
          isEdit={isEditNote}
          isAdd={isAddNote}
          actionItemId={id}
          planId={projectPlanId}
          onClose={() => {
            setIsNote(false);
            setIsEditNote(false);
            setIsNote(false);
          }}
        />

        {isNoteModel && (
          <ActionItemsModal
            isActionItem
            allData={data}
            data={notesData}
            isName={itemName}
            actionItemsModal={isNoteModel}
            setActionItemsModal={setIsNoteModel}
            projectPlanId={projectPlanId}
            PlanDetails={PlanDetails}
            isOnwer={isOnwer}
          />
        )}

        <Head>
          {(customizeColumns || []).some((col: any) => col.isFrozen) && (
            <FrozenWrapper>
              {FrozenHeadItem()}

              {(customizeColumns || [])
                .filter((column: any) => column.isFrozen)
                .map((column: any) => (
                  <Fragment key={column.key}>
                    {UnFrozenHeadItem({
                      column,
                      key: column.key,
                      isFrozen: true,
                    })}
                  </Fragment>
                ))}
            </FrozenWrapper>
          )}

          <UnFrozenWrapper>
            {!(customizeColumns || []).some((col: any) => col.isFrozen) &&
              FrozenHeadItem()}

            {(customizeColumns || [])
              .filter((column: any) => !column.isFrozen)
              .map((column: any) => (
                <Fragment key={column.key}>
                  {UnFrozenHeadItem({
                    column,
                    key: column.key,
                  })}
                </Fragment>
              ))}

            <Col $active={isCategoryActive} $type="medium" />

            {isNew ? null : <Col $active={isCategoryActive} $type="small" />}
          </UnFrozenWrapper>
        </Head>

        <ManageCustomMetricsModal
          IsAddMetric={IsAddMetric}
          setIsAddMetric={setIsAddMetric}
          visible={modalOpen}
          setModalOpen={setModalOpen}
          goalId={planDetails?.goal?.id}
          project_plan={projectPlanId}
        />

        <InviteUserModal
          isActive={!!emailToInvite}
          emailToInvite={emailToInvite ?? ""}
          onClose={() => setEmailToInvite(null)}
          onUserInvitedAndAdded={handleAssignNewUser}
        />
      </>
    );
  }
);
